import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import * as React from "react";

import { CustomButton } from "@/components/Button";

import { LoanConditionsDraft } from "../../../utils/purchaseLoanDraft";

import { LoanAmountPeriodEditor } from "./LoanAmountPeriodEditor";

interface Props {
  reason?: string;
  onRepaired: () => void;
  pendingBoughtAt?: string;
  draft?: LoanConditionsDraft;
  onDraft?: (draft: LoanConditionsDraft) => void;
  disabled?: boolean;
}

export const LoanConditionsRepair: React.FC<Props> = ({
  reason,
  onRepaired,
  pendingBoughtAt,
  draft,
  onDraft,
  disabled,
}) => {
  const [open, setOpen] = React.useState(false);
  if (!onDraft && reason !== "repayment_before_purchase" && reason !== "missing_initial_rate") return null;
  return (
    <>
      <CustomButton type="button" customVariant="textPrimary" onClick={() => setOpen(true)} disabled={disabled}>
        借入条件を確認・修正
      </CustomButton>
      <Dialog open={open} fullWidth maxWidth="sm" PaperProps={{ style: { maxWidth: 480, borderRadius: 16 } }}>
        <DialogTitle>借入条件を修正</DialogTitle>
        <DialogContent>
          {open && (
            <LoanAmountPeriodEditor
              initiallyEditing
              pendingBoughtAt={pendingBoughtAt}
              draft={draft}
              onDraft={
                onDraft
                  ? (value) => {
                      onDraft(value);
                      setOpen(false);
                      onRepaired();
                    }
                  : undefined
              }
              onSaved={() => {
                setOpen(false);
                onRepaired();
              }}
              onCancel={() => setOpen(false)}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
